function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import distanceInWordsToNow from "date-fns/distance_in_words_to_now";
//Material Imports
import Face from "@mui/icons-material/Face";
import Typography from "@mui/material/Typography";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import withStyles from "@mui/styles/withStyles";
//Limitless Imports
import { withi18n } from "../hocs/i18n";
import { locale } from "@limitless/common/utils";
import CustomerAvatar from "../customer-avatar/CustomerAvatar";
import UserAvatar from "../user-avatar/UserAvatar";
const messageLengthCount = 100;
class MessageHistoryListItem extends PureComponent {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "cropMessageTxt", messageTxt => {
      const newMessageTxt = messageTxt.length > messageLengthCount ? `${messageTxt.substring(0, messageLengthCount)}...` : messageTxt;
      return newMessageTxt;
    });
    _defineProperty(this, "showConversation", () => {
      this.props.onClickHandle(this.props.message);
    });
  }
  getAvatarFace() {
    const {
      message
    } = this.props;
    // We are getting image from Last dialogue, else default Avatar
    const expertDialogues = message.dialogues.filter(d => d.origin === "expert");
    if (expertDialogues && expertDialogues.length) {
      const lastDialogue = expertDialogues[expertDialogues.length - 1];
      const thumbnail = message.expertAuthors[lastDialogue.userId] ? message.expertAuthors[lastDialogue.userId].thumbnail : null;
      return /*#__PURE__*/React.createElement(UserAvatar, {
        author: lastDialogue.author,
        thumbnail: thumbnail
      });
    }
    return /*#__PURE__*/React.createElement(CustomerAvatar, null, /*#__PURE__*/React.createElement(Face, null));
  }
  getTime() {
    const {
      message,
      t
    } = this.props;
    if (message.closedDate) {
      return distanceInWordsToNow(message.closedDate, {
        locale: locale(t)
      });
    } else {
      const lastDialogue = message.dialogues[message.dialogues.length - 1];
      return distanceInWordsToNow(lastDialogue.updated, {
        locale: locale(t)
      });
    }
  }
  render() {
    const {
      t,
      classes
    } = this.props;
    return /*#__PURE__*/React.createElement("div", {
      onClick: this.showConversation,
      className: classes.listItemContainer
    }, this.getAvatarFace(), /*#__PURE__*/React.createElement("div", {
      className: classes.itemDetail
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.listRight
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "caption",
      className: classes.itemText
    }, this.cropMessageTxt(this.props.message.body)), /*#__PURE__*/React.createElement(KeyboardArrowRight, null)), /*#__PURE__*/React.createElement("div", {
      className: classes.itemStatus
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "caption",
      className: classes.pendingText
    }, t(this.props.message.messageStatus)), /*#__PURE__*/React.createElement(Typography, {
      variant: "caption"
    }, this.getTime()))));
  }
}
MessageHistoryListItem.propTypes = {
  message: PropTypes.object.isRequired,
  onClickHandle: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired
};

/* loading Style */
const styles = () => ({
  pendingText: {
    display: "flex",
    flex: 1
  },
  itemStatus: {
    display: "flex",
    paddingLeft: "8px",
    paddingTop: "4px"
  },
  itemDetail: {
    flexDirection: "row",
    padding: "5px",
    cursor: "pointer",
    minWidth: 0,
    flex: 1
  },
  listRight: {
    display: "flex",
    cursor: "pointer"
  },
  itemText: {
    paddingLeft: "8px",
    wordBreak: "break-word",
    wordWrap: "break-word",
    minWidth: 0,
    flex: 1,
    color: "rgba(0, 0, 0, 0.87)"
  },
  keyboardArrowRight: {
    alignSelf: "center",
    paddingLeft: "5px"
  },
  listItemContainer: {
    display: "flex",
    alignItems: "center",
    padding: "8px 16px",
    cursor: "pointer",
    textAlign: "left",
    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.04)"
    }
  }
});
export default withStyles(styles, {
  withTheme: true
})(withi18n(MessageHistoryListItem));